const dataPercentageHisto = [
    {
        country: 'Asia',
        year: '1750',
        value: 502,
    },
    {
        country: 'Asia',
        year: '1800',
        value: 635,
    },
    {
        country: 'Asia',
        year: '1850',
        value: 809,
    },
    {
        country: 'Asia',
        year: '1900',
        value: 947,
    },
    {
        country: 'Asia',
        year: '1950',
        value: 1402,
    },
    {
        country: 'Asia',
        year: '1999',
        value: 3634,
    },
    {
        country: 'Asia',
        year: '2050',
        value: 5268,
    },
    {
        country: 'Africa',
        year: '1750',
        value: 106,
    },
    {
        country: 'Africa',
        year: '1800',
        value: 107,
    },
    {
        country: 'Africa',
        year: '1850',
        value: 111,
    },
    {
        country: 'Africa',
        year: '1900',
        value: 133,
    },
    {
        country: 'Africa',
        year: '1950',
        value: 221,
    },
    {
        country: 'Africa',
        year: '1999',
        value: 767,
    },
    {
        country: 'Africa',
        year: '2050',
        value: 1766,
    },
    {
        country: 'Europe',
        year: '1750',
        value: 163,
    },
    {
        country: 'Europe',
        year: '1800',
        value: 203,
    },
    {
        country: 'Europe',
        year: '1850',
        value: 276,
    },
    {
        country: 'Europe',
        year: '1900',
        value: 408,
    },
    {
        country: 'Europe',
        year: '1950',
        value: 547,
    },
    {
        country: 'Europe',
        year: '1999',
        value: 729,
    },
    {
        country: 'Europe',
        year: '2050',
        value: 628,
    },
];

const linkedData = [
    { year: "2013", type: "Kernenergie", value: 92.1 },
    { year: "2013", type: "Braunkohle", value: 145.1 },
    { year: "2013", type: "Steinkohle", value: 110.6 },
    { year: "2013", type: "Gas", value: 39.4 },
    { year: "2013", type: "Wasserkraft", value: 21.0 },
    { year: "2013", type: "Biomasse", value: 48.3 },
    { year: "2013", type: "Wind", value: 47.2 },
    { year: "2013", type: "Solar", value: 29.7 },
    { year: "2014", type: "Kernenergie", value: 91.8 },
    { year: "2014", type: "Braunkohle", value: 140.9 },
    { year: "2014", type: "Steinkohle", value: 99.0 },
    { year: "2014", type: "Gas", value: 33.2 },
    { year: "2014", type: "Wasserkraft", value: 18.5 },
    { year: "2014", type: "Biomasse", value: 53.9 },
    { year: "2014", type: "Wind", value: 51.4 },
    { year: "2014", type: "Solar", value: 32.8 },
    { year: "2015", type: "Kernenergie", value: 87.1 },
    { year: "2015", type: "Braunkohle", value: 139.4 },
    { year: "2015", type: "Steinkohle", value: 103.9 },
    { year: "2015", type: "Gas", value: 30.0 },
    { year: "2015", type: "Wasserkraft", value: 20.2 },
    { year: "2015", type: "Biomasse", value: 56.5 },
    { year: "2015", type: "Wind", value: 84.6 },
    { year: "2015", type: "Solar", value: 36.8 },
    { year: "2016", type: "Kernenergie", value: 80.0 },
    { year: "2016", type: "Braunkohle", value: 134.8 },
    { year: "2016", type: "Steinkohle", value: 100.0 },
    { year: "2016", type: "Gas", value: 45.2 },
    { year: "2016", type: "Wasserkraft", value: 20.8 },
    { year: "2016", type: "Biomasse", value: 49.3 },
    { year: "2016", type: "Wind", value: 77.8 },
    { year: "2016", type: "Solar", value: 37.5 }
]

export { dataPercentageHisto, linkedData }